export default (props, vars) =>
  `https://drive.google.com/file/d/${props?.['id']}/preview`;
